import { filterPostsByTopicSlug, filterTrimesterPosts } from 'hello_baby/lib'
import GearView from 'hello_baby/components/GearView'
import PregnancyView from 'hello_baby/components/pregnancy-view'
import PregnancyWeekByWeekView from 'hello_baby/components/pregnancy-week-by-week-view'
import ParentingView from 'hello_baby/components/ParentingView'
import SampleRegistriesView from 'hello_baby/components/SampleRegistriesView'
import PostTeaserList from 'hello_baby/components/PostTeaserList/PostTeaserList'
import Loader from 'components/Loader'
import { babylistUrl, helloBabyPostPath } from 'lib/urls'
import {
  getSubTopics,
  getTopicDescriptionForSlug,
  getTopicPageTitleForSlug,
} from '../../reducers'
import {
  GEAR_SLUG,
  PARENTING_SLUG,
  PREGNANCY_SLUG,
  PREGNANCY_WEEK_BY_WEEK_SLUG,
  SAMPLE_REGISTRIES_SLUG,
  FRIENDS_AND_FAMILY_SLUG,
  PREGNANCY_FIRST_TRIMESTER_SLUG,
  PREGNANCY_SECOND_TRIMESTER_SLUG,
  PREGNANCY_THIRD_TRIMESTER_SLUG,
  YOUR_BABY_WEEK_BY_WEEK_SLUG,
} from '../../constants'
import FriendsAndFamilyView from '../FriendsAndFamilyView'
import HelloBabyMeta from '../HelloBabyMeta'
import { useSelector } from 'react-redux'

interface TopicViewProps {
  emailUrls: {}
  slug: string
}

const TopicView = ({ emailUrls, slug }: TopicViewProps) => {
  const state = useSelector((state: any) => state)
  const { posts } = state

  const subTopics = getSubTopics(state, slug)
  const topicDescription = getTopicDescriptionForSlug(slug, state)
  const topicPageTitle = getTopicPageTitleForSlug(slug, state)

  return (
    <>
      {!posts ||
      !Object.values(posts).find((post: any) =>
        post.meta.topics.map((topic: any) => topic['slug']).includes(slug)
      ) ? (
        <Loader className="center-xy" />
      ) : (
        <>
          <HelloBabyMeta
            canonical={babylistUrl(helloBabyPostPath(slug))}
            seoDescription={topicDescription}
            title={topicPageTitle}
          />
          {slug == GEAR_SLUG && (
            <GearView
              posts={filterPostsByTopicSlug(posts, slug)}
              subTopics={subTopics}
            />
          )}
          {slug == PARENTING_SLUG && <ParentingView slug={slug} />}
          {slug == PREGNANCY_SLUG && (
            <PregnancyView
              emailUrls={emailUrls}
              posts={posts}
              subTopics={subTopics}
            />
          )}
          {slug == FRIENDS_AND_FAMILY_SLUG && (
            <FriendsAndFamilyView slug={slug} />
          )}
          {slug == PREGNANCY_WEEK_BY_WEEK_SLUG && (
            <PregnancyWeekByWeekView posts={posts} />
          )}
          {slug == SAMPLE_REGISTRIES_SLUG && (
            <SampleRegistriesView slug={slug} />
          )}
          {slug == PREGNANCY_FIRST_TRIMESTER_SLUG && (
            <PostTeaserList posts={filterTrimesterPosts(posts, slug)} />
          )}
          {slug == PREGNANCY_SECOND_TRIMESTER_SLUG && (
            <PostTeaserList posts={filterTrimesterPosts(posts, slug)} />
          )}
          {slug == PREGNANCY_THIRD_TRIMESTER_SLUG && (
            <PostTeaserList posts={filterTrimesterPosts(posts, slug)} />
          )}
          {slug == YOUR_BABY_WEEK_BY_WEEK_SLUG && (
            <PostTeaserList
              posts={filterPostsByTopicSlug(posts, slug, {
                sortBy: 'slug',
                order: 'asc',
              })}
            />
          )}

          {[
            GEAR_SLUG,
            PARENTING_SLUG,
            PREGNANCY_SLUG,
            FRIENDS_AND_FAMILY_SLUG,
            PREGNANCY_WEEK_BY_WEEK_SLUG,
            SAMPLE_REGISTRIES_SLUG,
            PREGNANCY_FIRST_TRIMESTER_SLUG,
            PREGNANCY_SECOND_TRIMESTER_SLUG,
            PREGNANCY_THIRD_TRIMESTER_SLUG,
            YOUR_BABY_WEEK_BY_WEEK_SLUG,
          ].indexOf(slug) === -1 && (
            <PostTeaserList posts={filterPostsByTopicSlug(posts, slug)} />
          )}
        </>
      )}
    </>
  )
}

export default TopicView
